import React from "react";
import { makeStyles } from "@mui/styles";
import { colors } from "src/colors/colors";
import TextTitle from "../../../../commonStyles/text/textTitle/textTitle";
import { Fragment } from 'react';
const useStyles = makeStyles((theme) => {
  return {
    containerSteps: {
      ...theme.custom.flexBox.flexBetweenCenter,
      marginBottom: "32px",
      [theme.breakpoints.down("lg")]: {
        display: "none",
      },
    },
    step: {
      ...theme.custom.flexBox.flexBetweenCenter,
    },
    stepItem: {
      background: colors.white,
      ...theme.custom.flexBox.flexAlignItemsCenter,
      padding: "10px 16px",
      borderRadius: "32px",
    },
    stepNumber: {
      width: "28px",
      height: "28px",
      borderRadius: "50%",
      border: "1px solid rgba(211, 211, 211, 1)",
      ...theme.custom.flexBox.flexCenterCenter,
      marginRight: "8px",
      fontWeight: 500,
    },
    stepContent: {},
    textTitle: {
      fontSize: "14px",
      fontWeight: 600,
    },
    line: {
      height: "1px",
      background: "#ccc",
      margin: "0 16px",
      flex:"1"
    },
  };
});

interface IProps {
  step?: number;
  onPressStep?: (e?: any) => void;
}
const StepsPayment = (props: IProps) => {
  const { step = 0, onPressStep } = props;
  //! State
  const classes = useStyles();

  const highLightStepItem = (index) => {
    if (step === 0 && index === 0) {
      return {
        border: `1px solid ${colors.border.pinkDark}`,
        background: colors.background.pinkBlur,
      };
    }
    if (step === 1 && index === 0) {
      return { background: colors.background.pinkDark };
    }
    if (step === 1 && index === 1) {
      return {
        border: `1px solid ${colors.border.pinkDark}`,
        background: colors.background.pinkBlur,
      };
    }
    if (step === 2 && index === 0) {
      return { background: colors.background.pinkDark };
    }
    if (step === 2 && index === 1) {
      return { background: colors.background.pinkDark };
    }
    if (step === 2 && index === 2) {
      return {
        border: `1px solid ${colors.border.pinkDark}`,
        background: colors.background.pinkBlur,
      };
    }
    if (step === 3 && index === 0) {
      return { background: colors.background.pinkDark };
    }
    if (step === 3 && index === 1) {
      return { background: colors.background.pinkDark };
    }
    if (step === 3 && index === 2) {
      return { background: colors.background.pinkDark };
    }
    if (step === 3 && index === 3) {
      return {
        border: `1px solid ${colors.border.pinkDark}`,
        background: colors.background.pinkBlur,
      };
    }
  };
  const highLightNumber = (index) => {
    if (step === 0 && index === 0) {
      return {
        border: `1px solid ${colors.border.pinkDark}`,
        background: colors.background.pink,
        color: colors.white,
      };
    }
    if (step === 1 && index === 0) {
      return { background: colors.white, color: colors.text.pinkDark,border:"none" };
    }
    if (step === 1 && index === 1) {
      return {
        border: `1px solid ${colors.border.pinkDark}`,
        background: colors.background.pink,
        color: colors.white,
      };
    }
    if (step === 2 && index === 0) {
      return { background: colors.white, color: colors.text.pinkDark,border:"none" };
    }
    if (step === 2 && index === 1) {
      return { background: colors.white, color: colors.text.pinkDark,border:"none" };
    }
    if (step === 2 && index === 2) {
      return {
        border: `1px solid ${colors.border.pinkDark}`,
        background: colors.background.pink,
        color: colors.white,
      };
    }
    if (step === 3 && index === 0) {
      return { background: colors.white, color: colors.text.pinkDark,border:"none" };
    }
    if (step === 3 && index === 1) {
      return { background: colors.white, color: colors.text.pinkDark,border:"none" };
    }
    if (step === 3 && index === 2) {
      return { background: colors.white, color: colors.text.pinkDark,border:"none" };
    }
    if (step === 3 && index === 3) {
      return {
        border: `1px solid ${colors.border.pinkDark}`,
        background: colors.background.pink,
        color: colors.white,
      };
    }
  };
  const highLightText = (index) => {
    if (step === 0 && index === 0) {
      return {
        color: colors.text.pinkDark,
      };
    }
    if (step === 1 && index === 0) {
      return { color: colors.white };
    }
    if (step === 1 && index === 1) {
      return {
        color: colors.text.pinkDark,
      };
    }
    if (step === 2 && index === 0) {
      return { color: colors.white };
    }
    if (step === 2 && index === 1) {
      return { color: colors.white };
    }
    if (step === 2 && index === 2) {
      return {
        color: colors.text.pinkDark,
      };
    }
    if (step === 3 && index === 0) {
      return { color: colors.white };
    }
    if (step === 3 && index === 1) {
      return { color: colors.white };
    }
    if (step === 3 && index === 2) {
      return { color: colors.white };
    }
    if (step === 3 && index === 3) {
      return {
        color: colors.text.pinkDark,
      };
    }
  };
  return (
    <>
      <div className={classes.containerSteps}>
        {steps.map((stepContent, index) => {
          return (
            <Fragment key={index}>
            <div
              className={classes.step}
              onClick={() => {
                if (index < step) {
                  onPressStep(index);
                }
              }}
            >
              <div
                className={classes.stepItem}
                style={highLightStepItem(index)}
              >
                <TextTitle
                  className={` ${classes.textTitle} ${classes.stepNumber}`}
                  style={highLightNumber(index)}
                >
                  {index + 1}
                </TextTitle>
                <TextTitle
                  className={`${classes.textTitle}`}
                  style={highLightText(index)}
                >
                  {stepContent}
                </TextTitle>
              </div>
            </div>
              {index === 3 ? <></> : <div className={classes.line}></div>}
            </Fragment>
          );
        })}
      </div>
    </>
  );
};

export default StepsPayment;

const steps = [
  "Nhập thông tin truy vấn",
  "Thông tin thanh toán",
  "Hình thức thanh toán",
  "Kết quả thanh toán",
];
